import axios, { AxiosError } from 'axios';
import Router from 'next/router';
import { authAPIService } from './auth.service';

export const axiosInstance = axios.create({
  baseURL: '/api',
});

let refreshTokenPromise: ReturnType<typeof authAPIService.refreshToken> | undefined = undefined;

axiosInstance.interceptors.request.use((request) => {
  request.headers['Accept-Language'] = request.headers['Accept-Language'] ?? Router.locale;
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error: AxiosError) {
    const originalRequest: AxiosError['config'] & { _retry?: boolean } = error.config;
    /**
     * Only retry to refresh access token if status is 401
     * We using _retry to avoid infinity loop
     */
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== '/auth/refresh-token'
    ) {
      originalRequest._retry = true;
      // We only refresh the token once for all 401 requests.
      if (!refreshTokenPromise) {
        refreshTokenPromise = authAPIService.refreshToken().finally(() => {
          refreshTokenPromise = undefined;
        });
      }
      await refreshTokenPromise;
      return axiosInstance(originalRequest);
    }
    if (typeof error.response?.data?.message === 'string') {
      error.message = error.response?.data?.message;
    }
    return Promise.reject(error);
  },
);
